import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router';
import useAuth from '../../hooks/useAuth';
import './ServiceDetails.css'


const ServiceDetails = () => {
    const { serviceId } = useParams();
    const nameRef = useRef();
    const emailRef = useRef();
    const serviceRef = useRef();
    const statusRef = useRef()
    const { user } = useAuth();
    const [serviceDetails, setServiceDetails] = useState([]);
    const [singleService, setSingleService] = useState({});


    const handleAddBooking = (e) => {
        e.preventDefault();
        const name = nameRef.current.value;
        const email = emailRef.current.value;
        const service = serviceRef.current.value;
        const status = statusRef.current.value;


        const booking = { name, email, service, status };
        console.log(booking);
        fetch('https://salty-shelf-34271.herokuapp.com/booking', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(booking)

        })
            .then(res => res.json())
            .then(data => {
                if (data.insertedId) {
                    alert("Service Booked Successfully");
                    e.target.reset();
                }
            })



    }

    useEffect(() => {
        fetch('https://salty-shelf-34271.herokuapp.com/services')
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setServiceDetails(data)
            })


    }, [])

    useEffect(() => {
        const foundService = serviceDetails.find((service) => service._id === serviceId);
        setSingleService(foundService)
    }, [serviceDetails]);

    return (
        <div>
            <h2 className="my-4">Book Our <span className="text-danger">{singleService?.title}</span> Service </h2>
            <div className="container">

                <div className="card mb-3 mx-auto" style={{ maxWidth: "1200px" }}>
                    <div className="row g-0">
                        <div className="col-md-12 col-lg-5">
                            <img src={singleService?.img} height="100%" width="100%" alt="..." />

                        </div>
                        <div className=" col-md-12  col-lg-3">
                            <div className="card-body text-start">
                                <h2 className="card-title">{singleService?.title}</h2>
                                <p className="card-text text-start ">{singleService?.description}</p>
                                <p>Price: <span className='fw-bold'>$1000</span></p>
                                <p>Rating: <span className='fw-bold'>4.50</span></p>
                                <p>Booking Left: <span className='fw-bold'>20</span></p>

                            </div>
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <form onSubmit={handleAddBooking} className="bookservice p-3">
                                <h5>Your Name</h5>
                                <input style={{ width: "100%" }} type="text" ref={nameRef} name="" id="" />  <br /><br />
                                <h5>Your Email</h5>
                                <input style={{ width: "100%" }} type="text" ref={emailRef} value={user?.email} name="" id="" /> <br /><br />
                                <h5>Service Name</h5>
                                <input style={{ width: "100%" }} type="text" ref={serviceRef} value={singleService?.title} name="" id="" /> <br /><br />
                                <input style={{ width: "100%" }} type="text" ref={statusRef} value="Pending" /> <br /> <br />

                                {
                                    user?.email ? <input className="bg-success text-light p-2 mb-3 rounded fw-bold" type="submit" value="Book The Service" /> : <p className='text-danger'>If you are not login, please login by Gmail !!!</p>
                                }


                            </form>

                        </div>
                    </div>
                </div>

            </div>
        </div >
    );
};

export default ServiceDetails;


